import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import HuertoApp from './pages/HuertoApp';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/huerto/:id" element={<HuertoApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
